import { parseQuery } from "utils/parseQuery"

/**
 * The product lists (makeup, glasses, 3D) keep pagination in the URL — ?page=N
 * is their single source of truth. Every editor round-trip used to rebuild the
 * list URL from the bare pathname, so opening a card from page N and coming
 * back (back button, save, discard, leave-dialog) always landed on page 1
 * (Asana 1216893945878612).
 *
 * `withListPage(target, search)` carries the page across: append it to the
 * editor URL when leaving the list, and back onto the list URL when leaving
 * the editor. Page 1 (or a missing/garbage value) adds nothing — the lists
 * strip `page=1` from their own URLs.
 */
export const withListPage = (target: string, search: string): string => {
  const page = Number(parseQuery(search).page)
  if (!Number.isInteger(page) || page < 2) return target
  return `${target}${target.includes("?") ? "&" : "?"}page=${page}`
}
